import { render, staticRenderFns } from "./BuroDetayView.vue?vue&type=template&id=96257770&scoped=true"
import script from "./BuroDetayView.vue?vue&type=script&lang=ts"
export * from "./BuroDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96257770",
  null
  
)

export default component.exports